import React, { useEffect, useState } from 'react';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../../hook/use-http';
import styles from './MileageSaarathi.module.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';



function Summary_cards({ propsData, filterdata, onValueUpdate, /* onApiLoaded */ }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { title, apiEnd, dataKey, tooltipTxt, tooltip } = propsData
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!apiEnd) {
      setValue('--');
      // onApiLoaded && onApiLoaded(title?.replaceAll(' ', ''), true)
      return;
    }


    fetchData(
      {
        url: API_URL_MAIN + apiEnd,
        body: { filterdata }


      },
      (data) => {
        const valueFromAPI = data?.[dataKey]?.value ?? data?.[dataKey]?.count ?? '0';
        setValue(valueFromAPI);
        onValueUpdate?.(title?.replaceAll(' ', ''), valueFromAPI);
      }
    );

  }, [apiEnd, filterdata]);  // run effect when these change

  const InfoIcon = ({ tooltipText }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
      <span
        style={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <i
          className={`fas fa-info-circle ${styles.summary_icons}`}

        ></i>

        {showTooltip && (
          <div
            style={{
              position: 'absolute',
              bottom: '125%',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: '#fff',
              color: '#000',
              padding: '6px 10px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              whiteSpace: 'nowrap',
              fontSize: '13px',
              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
              zIndex: 9999
            }}
          >
            {tooltipText}
          </div>
        )}
      </span>
    );
  };

  const CustomTooltip = ({ tooltipText }) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-dynamic" className="custom-tooltip">
            {tooltipText}
          </Tooltip>
        }
      >
        <i
          className={`fas fa-info-circle ${styles.summary_icons}`}
        ></i>
      </OverlayTrigger>
    );
  };


  return (
    <div className="col-md-2">
      <div className="card h-40">

        <div className="card-body p-2 text-center d-flex flex-column justify-content-between">
          <div className='d-flex align-items-center justify-content-center'>
            <small className={`text-muted text-truncate d-block small ${styles.summary_vehicle_numbers}`}>{title} </small>
            {tooltip ? <CustomTooltip tooltipText={tooltipTxt} /> : <></>}
          </div>
          <h3 className="mt-2 mb-0">{value}</h3>
        </div>
      </div>
    </div >
  );
}

export default Summary_cards;